import { faChevronRight, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import AlertBox from "../../components/Messages";
import { useResetPasswordMutation } from "../../services/API/PasswordAPI";
import BasePage from "../BasePage/BasePage";
import "./ResetPassword.scss";

function ResetPassword() {
  const { t } = useTranslation(["resetPassword", "login"]);

  const [sendResetReqeust, { isLoading }] = useResetPasswordMutation();

  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [formState, setFormState] = useState({
    usernameOrEmail: "",
  });
  const handleChange = ({ target: { name, value } }) => {
    return setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLoading) return;
    if (formState.usernameOrEmail === "") return setErrMsg(t("error.noUsername"));

    try {
      await sendResetReqeust(formState).unwrap();
    } catch (err) {
      if (err?.originalStatus === 200) return setSuccessMsg(t("success"));

      //TODO: rework with api validation and errors in response instead of statuscodes
      // 'status' if response is json, 'originalStatus' if response was parsed wrong because its plain text
      if (!err?.status) {
        setErrMsg(t("error.noServerResponse", { ns: "login" }));
      } else if (err?.status === 400 || err?.originalStatus === 400) {
        setErrMsg(t("error.noUsernameOrPassword", { ns: "login" }));
      } else if (err?.status === 401 || err?.originalStatus === 401) {
        setErrMsg(t("error.unauthorized", { ns: "login" }));
      } else if (err?.status === 404 || err?.originalStatus === 404) {
        setErrMsg(t("error.notFound"));
      } else if (err?.status === 423 || err?.originalStatus === 423) {
        setErrMsg(t("error.inactiveUser", { ns: "login" }));
      } else if (err?.status === 901 || err?.originalStatus === 901) {
        setErrMsg(t("error.unverifiedEmail", { ns: "login" }));
      } else {
        setErrMsg(t("error.generalFailure"));
      }
    }
  };

  useEffect(() => {
    setErrMsg("");
  }, [formState]);

  return (
    <BasePage size={5}>
      <div className="p-md-5 mx-md-4">
        <div className="spacer"></div>
        <h1 className="my-5 pb-1 login-headline">{t("title")}</h1>

        <div>{t("infoText")}</div>

        <FloatingLabel
          className="my-md-5"
          controlId="usernameOrEmail"
          label={t("formTitle", { ns: "resetPassword" })}
        >
          <Form.Control
            onChange={handleChange}
            value={formState.usernameOrPassword}
            type="text"
            className="custom-Border"
            placeholder={t("formTitle", { ns: "resetPassword" })}
            name="usernameOrEmail"
            required
          />
        </FloatingLabel>

        <Link className="forgot-password" to={"/"}>
          {t("backtoLogin", { ns: "resetPassword" })}
        </Link>

        <AlertBox show={errMsg !== ""} message={errMsg} />
        <AlertBox show={successMsg !== ""} message={successMsg} customVariant="success" />

        <br />
        <div className="pt-md-1 my-md-5 pb-md-1">
          <button className="login-button" type="button" onClick={handleSubmit}>
            <div className="verticallyAligned">
              <div>{t("submitButton")}</div>
              <div style={{ marginLeft: "25px" }}>
                {isLoading ? (
                  <FontAwesomeIcon color="yellow" icon={faSpinner} className={"fa-spin"} />
                ) : (
                  <FontAwesomeIcon color="yellow" icon={faChevronRight} />
                )}
              </div>
            </div>
          </button>
        </div>
        <br />
      </div>
    </BasePage>
  );
}

export default ResetPassword;
